import { SetStateAction } from 'react';

import { HistoryContext } from '../../HistoryManager/contextType';

export enum UserPreferenceKeys {
  ideLayoutFlip = 'ideLayoutFlip',
  codeViewSplitEditor = 'codeViewSplitEditor',
  viewType = 'viewType',
  SQLVariantSamplingLimit = 'SQLVariantSamplingLimit',
  projectBrowserDefaultTab = 'projectBrowserDefaultTab',
  OrchFabricOAuthReminder = 'OrchFabricOAuthReminder',
  showAllCommitsInReplayBuilder = 'showAllCommitsInReplayBuilder',
  replay = 'replay',
  onboardingTourCompleted_v425 = 'onboardingTourCompleted_v425',
  newUserSignupAutoProjectClone = 'newUserSignupAutoProjectClone',
  projectBrowserOpen = 'projectBrowserOpen',
  verticalAppsRecentActivity = 'verticalAppsRecentActivity',
  verticalAppsRecentProjects = 'verticalAppsRecentProjects',
  verticalAppsCurrentWorkspaceId = 'verticalAppsCurrentWorkspaceId',
  reformatOnboardingCompleted = 'reformatOnboardingCompleted',
  reformatFeedbackSubmitted = 'reformatFeedbackSubmitted',
  sqlFavouriteGems = 'sqlFavouriteGems',
  isSqlFavouritesBarVisible = 'isSqlFavouritesBarVisible',
  copilotAiDisclaimerDismissedText = 'copilotAiDisclaimerDismissedText',
  lastGoodAIFeedback = 'lastGoodAIFeedback',
  dontShowUnmappedColumnsWarning = 'dontShowUnmappedColumnsWarning',
  dontShowSqlIdeInterimMetadataWarning = 'dontShowSqlIdeInterimMetadataWarning',
  projectBrowserEntitySort = 'projectBrowserEntitySort',
  sqlCanvasGemIndicators = 'sqlCanvasGemIndicators',
  homeChatPinnedConversations = 'homeChatPinnedConversations',
  homeChatLastConversation = 'homeChatLastConversation'
}

export enum ProjectPreferenceKeys {
  sqlBrowserSettings = 'sqlBrowserSettings',
  expandedEntities = 'expandedEntities',
  projectBrowserDefaultTab = 'projectBrowserDefaultTab',
  openEntityTabs = 'openEntityTabs',
  lastExportedHarmoDataset = 'lastExportedHarmoDataset',
  recentActivity = 'recentActivity',
  verticalAppsShowFullWidthChat = 'verticalAppsShowFullWidthChat',
  lastOntologyMappingTarget = 'lastOntologyMappingTarget',
  lastOpenedOntologyType = 'lastOpenedOntologyType',
  lastOntologyWriteTarget = 'lastOntologyWriteTarget'
}

export type SetPreferenceOptions = {
  saveInHistory?: boolean;
  historyMergeId?: string;
  metadata?: Record<string, unknown>;
};

export type SetPreference<M> = <T extends keyof M>(
  key: T,
  value: SetStateAction<M[T]>,
  options?: SetPreferenceOptions,
  history?: HistoryContext
) => void;

export type PreferenceContextType<T> = {
  preferences: T;
  setPreference: SetPreference<T>;
};
